import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { Link } from "react-router-dom"
import { ColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import Icon from "../../../../../icon/icon.component"

export default (columnDefinition: ColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => (
        info.getValue() ? (
            <>
                <Link to={`/contacts/${info.row.original.contactId}/details`}>
                    {info.getValue() ?? "-"}
                </Link>
                {info.row.original.contact?.organizationId && (
                    <Link className="ml-1" to={`/contacts/${info.row.original.contact.organizationId}/details`}>
                        <small><Icon value="building" />{info.row.original.contact.organizationName}</small>
                    </Link>
                )}
            </>
        ) : (
            columnDefinition.dataAttributes?.defaultValue || "-"
        )
    )
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/ContactCellMapper.tsx